import { render, staticRenderFns } from "./unknown.vue?vue&type=template&id=37002623&scoped=true&"
import script from "./unknown.vue?vue&type=script&lang=js&"
export * from "./unknown.vue?vue&type=script&lang=js&"
import style0 from "./unknown.vue?vue&type=style&index=0&id=37002623&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37002623",
  null
  
)

export default component.exports